<div class="rectangle-button">
  <span *ngIf="!loading" class="buttonsCTA2 button-content" (click)="onClickButton($event)">{{ label }}</span>
  <div class="button-content" *ngIf="loading">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>

